import { Component, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PrintScreenAlertService {
    showAlert;
}


@Component({
    selector: 'print-screen-alert',
    templateUrl: './print-screen-alert.component.html',
    styleUrls: ['./print-screen-alert.component.scss'],
    standalone: false
})
export class PrintScreenAlertComponent {
  message: string = 'Não é permitido fazer PrintScreen da Tela da TemAPI. Verificar suas permissões.';

  constructor ( public ps:PrintScreenAlertService){}
  
  closeAlert() {
    this.ps.showAlert = false;
  }
}